
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/[...url_slug]",
      function () {
        return require("private-next-pages/reviews/[...url_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/[...url_slug]"])
      });
    }
  